import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * Loads public auth config (including reCAPTCHA site key).
 */
export const useAuthConfig = () => {
  const [config, setConfig] = useState({
    loading: true,
    recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_V2_SITE_KEY || '',
    recaptchaEnabled: false,
  });

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      const fallbackSiteKey = process.env.REACT_APP_RECAPTCHA_V2_SITE_KEY || '';
      try {
        const res = await axios.get(`${API_URL}/auth/config`);
        if (cancelled) return;
        const siteKey = res.data?.recaptchaSiteKey || fallbackSiteKey;
        setConfig({
          loading: false,
          emailVerificationRequired: res.data?.emailVerificationRequired,
          emailConfigured: res.data?.emailConfigured,
          stripeConfigured: res.data?.stripeConfigured,
          recaptchaSiteKey: siteKey,
          recaptchaEnabled: Boolean(res.data?.recaptchaEnabled && siteKey),
        });
      } catch {
        if (cancelled) return;
        setConfig({
          loading: false,
          recaptchaSiteKey: fallbackSiteKey,
          recaptchaEnabled: Boolean(fallbackSiteKey),
        });
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return config;
};

export default useAuthConfig;
